/**
 * Book language code ↔ default flag image under `public/flags/`.
 * Empty `filename` means no bundled flag for that code (code still selectable).
 */
export const LANGUAGE_ENTRIES = [
  { code: 'mn', filename: 'mongolia.png', name: 'Монгол' },
  { code: 'en', filename: 'us.png', name: 'English' },
  { code: 'de', filename: 'germany.png', name: 'Deutsch' },
  { code: 'sv', filename: 'sweden.png', name: 'Svenska' },
  { code: 'ja', filename: 'japan.png', name: '日本語' },
  { code: 'ko', filename: 'korea.png', name: '한국어' },
  { code: 'zh', filename: 'china.png', name: '中文' },
  { code: 'ru', filename: 'russia.png', name: 'Русский' },
  { code: 'it', filename: 'italy.png', name: 'Italiano' },
  { code: 'es', filename: 'spain.png', name: 'Español' },
  { code: 'fr', filename: 'france.png', name: 'Français' },
  { code: 'pl', filename: 'poland.png', name: 'Polski' },
  { code: 'tr', filename: 'turkey.png', name: 'Türkçe' },
] as const;

export type BookLanguageCodeFlagAssociation = (typeof LANGUAGE_ENTRIES)[number];

export const BOOK_LANGUAGE_CODES = LANGUAGE_ENTRIES.map((a) => a.code);

export type BookLanguageCode = (typeof LANGUAGE_ENTRIES)[number]['code'];

const codeToFlag: Map<string, string> = new Map(
  LANGUAGE_ENTRIES.map((a) => [a.code, a.filename]),
);

export function isBookLanguageCode(id: string): id is BookLanguageCode {
  return codeToFlag.has(id);
}

/** Default flag basename for a known code, or `undefined` if unknown. */
export function getBookLanguageFlagFilename(code: string): string | undefined {
  return codeToFlag.get(code);
}
